@if (completionFroms.length > 0) {
<div class="p-0 schedule-completion-form">
  <span class="page-indicator-text">{{ pageIndicatorText }}</span>
  <div class="row mt-5">
    <ngb-carousel class="main-carousel" (slide)="onSlide($event)">
      @for (form of completionFroms; track form; let i = $index) {
      <ng-template ngbSlide [id]="i.toString()">
        <div class="row completionForm m-0 p-0 mt-2">
          <div class="px-2">
            <span><b>{{ clientdata.clientName }}</b></span>
          </div>
          <div class="px-2">
            <span><b>{{ clientdata.clientIdentificationType }}:
                {{ clientdata.clientDni }}</b></span>
          </div>
          <div class="px-2 mb-4">
            <span><b>
                {{ form.creationDate | date : "dd-MM-yyyy" }}
              </b>
            </span>
          </div>
          @if (form.approved != null) {
          <div class="col-6 ps-2 mb-2">
            <span><b>{{ form.approved ? "Aprobado" : "Rechazado" }} por el
                cliente</b></span>
          </div>
          }
          @if (form.approved != null) {
          <div class="col-6 ps-2 mb-1">
            <span>{{ form.clientComment }}</span>
          </div>
          }

          @for (group of form.groups; track group) {
          @if (hasVisibleFields(group)) {
          <div class="px-2 mb-4" [ngClass]="{'col-6': form.groups.length > 2, 'col-12': form.groups.length <= 2}">
            <div class="group-header">
              <b>{{ group.name }}</b>
            </div>
            <div class="mt-2">
              @for (field of group.fields; track field; let idx = $index) {
              @if (field.type.toString() !== '10') {
              <div class="w-100 mb-1" [innerHtml]="drawDynamicReportContent(group.fields, idx)"></div>
              }
              }
            </div>
          </div>
          }
          }

          @if (form.files && form.files.length > 0) {
          <div class="pt-4 border-top">

            <div class="mb-4 d-flex justify-content-between align-items-center flex-wrap">

              <div class="d-flex align-items-center">
                <mat-icon class="me-2 gallery-icon-gray">collections</mat-icon>
                <b>
                  Galería de Fotos y Vídeos
                </b>
              </div>

              <div class="d-flex flex-wrap gap-2 justify-content-end">
                <button type="button" class="pill-button" [class.active]="selectedMediaGroup === 'Todas'"
                  (click)="selectedMediaGroup = 'Todas'">
                  Todas
                </button>

                @for (g of getAvailableMediaGroups(form); track g.id) {
                <button type="button" class="pill-button" [class.active]="selectedMediaGroup === g.id"
                  (click)="selectedMediaGroup = g.id">
                  {{ g.name }}
                </button>
                }
              </div>
            </div>

            <div class="px-2">
              @let filtered = getFilteredFiles(form.files);

              @if (filtered.length > 0) {
              <app-images-carousel [files]="filtered"></app-images-carousel>
              } @else {
              <div class="no-media-message py-5 text-center border rounded">
                <mat-icon class="d-block mx-auto mb-2 text-muted" style="font-size: 40px; width: 40px; height: 40px;">
                  image_not_supported
                </mat-icon>
                <span class="text-muted">No hay imágenes o vídeos para visualizar en esta categoría.</span>
              </div>
              }
            </div>
          </div>
          }
        </div>

        @if (!fileUploader) {
        <button class="attach-files mt-2" (click)="showFileUploader()">
          Agregar imagen/video
          <mat-icon>attach_file</mat-icon>
        </button>
        }
        @if (loader) {
        <div class="loader"></div>
        }
        @if (fileUploader) {
        <div class="mt-3" [formGroup]="imageUploadreForm">
          <app-file-uploader [description]="'Aqui puede adjuntar imagenes relacionadas a la obra'" [name]="'name'"
            [settings]="uploadersetting" (sendImgsToParent)="loadFile($event)">
          </app-file-uploader>

          <div class="text-end"> <button type="button" class="no-back-color" (click)="submitFile()"
              [disabled]="imageUploadreForm.invalid || loader">
              Guardar archivo
            </button>
          </div>
        </div>
        }
      </ng-template>
      }
    </ngb-carousel>
  </div>
</div>
}